import React, { Suspense, useEffect } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import LoadingPage from '../modules/consulta/components/LoadingPage';
import Logout from './../modules/consulta/pages/auth/Logout';
import { ProtectedRoute } from '../shared/components';
import Statistics from "../modules/consulta/pages/Statistics";
import StatisticsDetails from "../modules/consulta/pages/Statistics/StatisticsDetails";

import DadosDoAcervo from "../modules/consulta/pergamum_kids/components/DadosDoAcervo";
import BaseTemplateTeen from "../modules/consulta/pergamum_kids/template/BaseTemplateTeen";
import AppContextProvider from '../shared/contexts/AppContextProvider';
import ApplicationProviders from '../shared/contexts/ApplicationProviders';
import RestrictCollection from '../modules/consulta/pages/auth/RestrictCollection';
import RestrictedAccess from '../modules/consulta/components/DadosAcervo/RestrictedAccess';
import DadosAcervoBiblioteca from '../modules/consulta/pages/home/DadosAcervoBiblioteca';
const Home = React.lazy(() => import('./../modules/consulta/pages/home/Home'));
const Login = React.lazy(() => import('./../modules/consulta/pages/auth/Login'));
const DadosAcervo = React.lazy(() => import('./../modules/consulta/pages/home/DadosAcervo'));
const PearsonAuthPage = React.lazy(() => import('./../modules/consulta/pages/auth/PearsonAuthPage'));
const DadosAutoridade = React.lazy(() => import('./../modules/consulta/pages/home/DadosAutoridade'));
const Cesta = React.lazy(() => import('./../modules/consulta/pages/home/Cesta'));
const ErrorPage = React.lazy(() => import('./../modules/consulta/components/ErrorPage'));
const MeuPergamum = React.lazy(() => import('../modules/meupergamum'));
const PergamumRedireciona = React.lazy(() => import('./../modules/consulta/pages/auth/PergamumRedireciona'));
const OAuthResponse = React.lazy(() => import('../modules/consulta/pages/auth/OAuthResponse'));
const GrupoA = React.lazy(() => import('./../modules/consulta/pages/auth/GrupoA'));
const AppLayers = React.lazy(() => import('./../modules/meupergamum/pages/AppLayers'));
const SamlResponse = React.lazy(() => import('./../modules/consulta/pages/auth/SamlResponse'));
const AlertaBibliografico = React.lazy(() => import('../modules/consulta/pages/AlertaBibliografico'));
const NadaConstaValidateQRCode = React.lazy(() => import('../modules/consulta/pages/NadaConstaValidateQrCode'));

//Pergamum kids

const HomePergamumKids = React.lazy(() =>
    import('../modules/consulta/pergamum_kids/pages/Home'),
);

const AccessibilityContextProvider = React.lazy(() =>
    import('../modules/consulta-acessibilidade/contexts/AccessibilityContext'),
);

const AccessibilitySearchAbout = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearchAbout'),
);
const AccessibilitySearch = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearch'),
);
const AccessibilitySearchResults = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearchResults'),
);
const AccessibilitySearchPreResult = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearchPreResult'),
);

const AccessibilitySearchFilters = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearchFilters'),
);

const AccessibilitySearchDetails = React.lazy(() =>
    import('../modules/consulta-acessibilidade/AccessibilitySearchDetails'),
);

const AccessibilitySearchFaq = React.lazy(() =>
    import('../modules/consulta-acessibilidade/faq/AccessibilitySearchFaq'),
);

const AccessibilitySearchLibraries = React.lazy(() =>
    import("../modules/consulta-acessibilidade/AccessibilitySearchLibraries"),
);


const Routers = () => (
    <Suspense fallback={<LoadingPage />}>
        <BrowserRouter basename={process.env.REACT_APP_PREFIX}>
           <ApplicationProviders>
               <Switch>
                   <Route path="/" exact component={Home} />
                   <Route path="/login" render={props => <Login {...props} />} />
                   <Route path="/sair" render={props => <Logout {...props} />} />
                   <Route path="/pergamum_redireciona" render={props => <PergamumRedireciona {...props} />} />
                   <Route path="/oauth-response" render={props => <OAuthResponse {...props} />} />
                   <Route path="/saml-response" render={props => <SamlResponse {...props} />} />
                   <Route path="/grupoa" render={props => <GrupoA {...props} />} />
                   <Route path="/alerta-bibliografico" render={props => <AlertaBibliografico {...props} />} />
                   {/* Rotas para a pesquisa de acessibilidade */}
                   <Route path="/pesquisa_acessibilidade">
                       <AccessibilityContextProvider>
                           <Switch>
                               <Route
                                   exact
                                   path="/pesquisa_acessibilidade"
                                   component={AccessibilitySearch}
                               />
                               <Route
                                   path="/pesquisa_acessibilidade/sobre"
                                   component={AccessibilitySearchAbout}
                               />

                               <Route
                                   path="/pesquisa_acessibilidade/bibliotecas/:codAcervo"
                                   component={AccessibilitySearchLibraries}
                               />
                               <Route
                                   path="/pesquisa_acessibilidade/resultados"
                                   component={AccessibilitySearchResults}
                               />
                               <Route
                                   path="/pesquisa_acessibilidade/pre-resultado"
                                   component={AccessibilitySearchPreResult}
                               />
                               <Route
                                   path="/pesquisa_acessibilidade/filtros"
                                   component={AccessibilitySearchFilters}
                               />
                               <Route
                                   path="/pesquisa_acessibilidade/detalhes/:codAcervo/:codBiblioteca?"
                                   component={AccessibilitySearchDetails}
                               />
                               <Route
                                   path="/pesquisa_acessibilidade/duvidas-frequentes"
                                   component={AccessibilitySearchFaq}
                               />
                               <Route
                                   path="*"
                                   render={props => <ErrorPage {...props} />}
                               />
                           </Switch>
                       </AccessibilityContextProvider>
                   </Route>
                   {/* Rotas para a pesquisa de acessibilidade */}

                   {/* ROTAS KIDS */}
                   <Route exact path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca" render={props => <HomePergamumKids extras={false} showDadosAcervo acervoCompleto {...props} />}  />
                   <Route exact path="/catalogos/:prefix/acervo/simple/:codAcervo/:codBiblioteca" render={props => <HomePergamumKids extras={false} showDadosAcervo {...props} />}  />

                   {/*<Route exact path="/pergamum-kids/:codBiblioteca?/:codCategoria?" render={props => <HomePergamumKids {...props} />} />*/}

                   <Route exact path="/catalogos/:prefix/:codBiblioteca?/:codCategoria?" render={props => <HomePergamumKids {...props} />} />

                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/referencia"
                       exact
                       render={props => (
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'33'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/marc"
                       exact
                       render={props => (
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'36'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/exemplares"
                       exact
                       render={props => (
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'30'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/dublin-core"
                       exact
                       render={props => (
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'115'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/reserva"
                       exact
                       render={props => (
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'18'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/solicitacao-emprestimo"
                       exact
                       render={props => (
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'75'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/catalogos/:prefix/acervo/:codAcervo/:codBiblioteca/colecao-kardex"
                       exact
                       render={props => (
                           <HomePergamumKids
                               showDadosAcervo
                               acervoCompleto
                               extras={false}
                               linkCurrent={'32'}
                               {...props}
                           />
                       )}
                   />
                   {/* ROTAS KIDS */}

                   {/* ROTAS ESTATISTICAS */}
                   <Route exact path="/estatistica" render={props => <Statistics {...props} />} />
                   <Route exact  path="/estatistica/:route" render={props => <StatisticsDetails {...props} />} />
                   {/* ROTAS ESTATISTICAS */}

                   {/* Rota para fazer a autenticação para ebooks da pearson */}
                   <Route
                       path="/pearson"
                       exact
                       render={props => <PearsonAuthPage {...props} />}
                   />
                   {/* Cesta */}
                   <Route
                       path="/cesta"
                       exact
                       render={props => <Cesta {...props} />}
                   />
                   {/* Módulo Meu Pergamum */}
                   <Route path="/meupergamum/app" render={props => <AppLayers {...props} />} />
                   <ProtectedRoute path="/meupergamum" component={MeuPergamum} />
                   {/* Alterar rotas conforme navega no menu:  */}
                   <Route
                       path="/:guia"
                       exact
                       render={props => <Home {...props} />}
                   />
                   {/* Dados do acervo: */}
                   <Route
                       path="/acesso-restrito/:codAcervo"
                       exact
                       render={props => <RestrictedAccess {...props} />}
                   />
                   <Route
                       path="/acervo/:codAcervo/restrito"
                       exact
                       render={props => <RestrictCollection {...props} />}
                   />
                   <Route
                       path="/acervo/:codAcervo"
                       exact
                       render={props => <DadosAcervo extras={false} {...props} />}
                   />
                   <Route
                       path="/acervo/:codAcervo/referencia"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent="33"
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/acervo/:codAcervo/marc"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent={'36'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/acervo/:codAcervo/exemplares"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent={'30'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/acervo/:codAcervo/dublin-core"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent={'115'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/acervo/:codAcervo/reserva"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent={'18'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/acervo/:codAcervo/solicitacao-emprestimo"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent={'75'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/acervo/:codAcervo/solicitacao-emprestimo-delivery"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent='128'
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/acervo/:codAcervo/colecao-kardex"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent={'32'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/acervo/:codAcervo/sumarios"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent={'summary'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/acervo/:codAcervo/sumarios-livros"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent={'sumario_livro'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                       path="/acervo/:codAcervo/dados-estatisticos"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent={'74'}
                               {...props}
                           />
                       )}
                   />
                   <Route
                        path="/biblioteca/:codAcervo"
                        exact
                        render={props => (
                            <DadosAcervoBiblioteca {...props} />
                        )}
                    />
                   {/* Dados da Autoridade */}
                   <Route
                       path="/autoridade/:codAutoridade"
                       exact
                       render={props => (
                           <DadosAutoridade linkCurrent={'def'} {...props} />
                       )}
                   />
                   <Route
                       path="/autoridade/:codAutoridade/marc"
                       exact
                       render={props => (
                           <DadosAutoridade linkCurrent={'marc'} {...props} />
                       )}
                   />
                   <Route
                       path="/acervo/:codAcervo/acervo-fechado"
                       exact
                       render={props => (
                           <DadosAcervo
                               extras={false}
                               linkCurrent="acervo_fechado"
                               {...props}
                           />
                       )}
                   />

                   <Route
                       path="/nada-consta-validate-qrcode/:cod/:valid/:motivo"
                       exact
                       render={props => (
                           <NadaConstaValidateQRCode {...props} />
                       )}
                   />

                   <Route path="*" render={props => <ErrorPage {...props} />} />
               </Switch>
           </ApplicationProviders>
        </BrowserRouter>
    </Suspense>
);

export default Routers;
